
import PenClose from "../../../assets/outline/PenClose.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PenCloseIcon({ className, dataTestid = "PenCloseIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PenClose data-testid={dataTestid} className={classes} {...rest} />
  );
}
